import styled from "styled-components";
import React from "react";

const StyledOutput = ({ label, unit, value, ...props }) => {
    return (
        <Label>
            <LabelText>{label}</LabelText>
            <InputWrapper>
                <Input
                    {...props}
                    value={value}
                    disabled
                />
                {unit && <Unit>{unit}</Unit>}
            </InputWrapper>
        </Label>
    );
};

export default StyledOutput;

const Label = styled.label`
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: #374151;
    font-weight: 500;
`;

const LabelText = styled.span`
    font-size: 0.875rem;
`;

const InputWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const Input = styled.input`
    width: 100%;
    padding: 8px 16px;
    text-align: right;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    transition: all 0.3s;
    outline: none;
    ${({ spacing }) => (spacing ? `padding-right: ${spacing}px;` : 'padding-right: 64px;')}

    &:focus {
        ring: 2px solid #3b82f6;
        outline: none;
    }
`;

const Unit = styled.span`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
    font-size: 0.875rem;
`;